import { render, staticRenderFns } from "./StSelect.vue?vue&type=template&id=0453e9c8&scoped=true"
import script from "./StSelect.vue?vue&type=script&lang=js"
export * from "./StSelect.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/components/shared/_st-select.scss?vue&type=style&index=0&id=0453e9c8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0453e9c8",
  null
  
)

export default component.exports